module.exports = __webpack_public_path__ + "img/MeerInDerLuft.84b34424.svg";